module.exports = __webpack_public_path__ + "static/media/appstore@2x.129a019f.png";